import React from 'react';
import PropTypes from 'prop-types';

import * as NameTagsNamePlates from './NameTagsNamePlates';

import * as ExteriorSigns from './SignsGraphics/ExteriorSigns';
import * as InteriorSigns from './SignsGraphics/InteriorSigns';
import * as IndustrialMarking from './IndustrialMarking';
import * as SignsGraphics from './SignsGraphics';
import * as StampsSeals from './StampsSeals';
import * as VinylLetteringGraphics from './SignsGraphics/VinylLetteringGraphics';


const ComponentLoader = ({
  component,
  submitForm,
}) => {
  // IndustrialMarking
  if (component === './IndustrialMarking/MachinePlates') {
    return ( <IndustrialMarking.MachinePlates.Component submitForm={submitForm} />);
  }
  
  if (component === './IndustrialMarking/SecuritySeals') {
    return ( <IndustrialMarking.SecuritySeals.Component submitForm={submitForm} /> );
  }
  if (component === './IndustrialMarking/Stencils') {
    return ( <IndustrialMarking.Stencils.Component submitForm={submitForm} /> );
  }
  if (component === './IndustrialMarking/TagsLamacoids') {
    return ( <IndustrialMarking.TagsLamacoids.Component submitForm={submitForm} /> );
  }

  // NameTagsNamePlates
  if (component === './NameTagsNamePlates/NameTags') {
    return ( <NameTagsNamePlates.NameTags.Component submitForm={submitForm} /> );
  }
  if (component === './NameTagsNamePlates/NamePlates') {
    return ( <NameTagsNamePlates.NamePlates.Component submitForm={submitForm} /> );
  }

  // SignsGraphics
  if (component === './SignsGraphics/DimensionalLettersLogos') {
    return ( <SignsGraphics.DimensionalLettersLogos.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/DonorWallsRecognitionPlaques') {
    return ( <SignsGraphics.DonorWallsRecognitionPlaques.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/FrostedWindowFilms') {
    return ( <SignsGraphics.FrostedWindowFilms.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/SiteSignsSafetySigns') {
    return ( <SignsGraphics.SiteSignsSafetySigns.Component submitForm={submitForm} /> );
  }

  // ExteriorSigns
  if (component === './SignsGraphics/ExteriorSigns/BuildingSignage') {
    return ( <ExteriorSigns.BuildingSignage.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/ExteriorSigns/DirectionalWayfinding') {
    return ( <ExteriorSigns.DirectionalWayfinding.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/ExteriorSigns/IlluminatedSignage') {
    return ( <ExteriorSigns.IlluminatedSignage.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/ExteriorSigns/ParkingLotSigns') {
    return ( <ExteriorSigns.ParkingLotSigns.Component submitForm={submitForm} /> );
  }

  // InteriorSigns
  if (component === './SignsGraphics/InteriorSigns/BrailleAdaSigns') {
    return ( <InteriorSigns.BrailleAdaSigns.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/DirectionalWayfinding') {
    return ( <InteriorSigns.DirectionalWayfinding.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/Directories') {
    return ( <InteriorSigns.Directories.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/MenuBoards') {
    return ( <InteriorSigns.MenuBoards.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/ModularSignSystems') {
    return ( <InteriorSigns.ModularSignSystems.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/OfficeDoorSigns') {
    return ( <InteriorSigns.OfficeDoorSigns.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/ReceptionSigns') {
    return ( <InteriorSigns.ReceptionSigns.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/InteriorSigns/Regulatory') {
    return ( <InteriorSigns.Regulatory.Component submitForm={submitForm} /> );
  }

  // VinylLetteringVinylDecals
  if (component === './SignsGraphics/VinylLetteringGraphics/Banners') {
    return ( <VinylLetteringGraphics.Banners.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/VinylLetteringGraphics/Decals') {
    return ( <VinylLetteringGraphics.Decals.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/VinylLetteringGraphics/HoardingGraphics') {
    return ( <VinylLetteringGraphics.HoardingGraphics.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/VinylLetteringGraphics/SandwichBoards') {
    return ( <VinylLetteringGraphics.SandwichBoards.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/VinylLetteringGraphics/WallGraphics') {
    return ( <VinylLetteringGraphics.WallGraphics.Component submitForm={submitForm} /> );
  }
  if (component === './SignsGraphics/VinylLetteringGraphics/WindowDoorGraphics') {
    return ( <VinylLetteringGraphics.WindowDoorGraphics.Component submitForm={submitForm} /> );
  }

  // StampsSeals
  if (component === './StampsSeals/BrandingStamps') {
    return ( <StampsSeals.BrandingStamps.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/DateStamps') {
    return ( <StampsSeals.DateStamps.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/PreInkedStamps') {
    return ( <StampsSeals.PreInkedStamps.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/Seals') {
    return ( <StampsSeals.Seals.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/SelfInkingStamps') {
    return ( <StampsSeals.SelfInkingStamps.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/SpecialtyStamps') {
    return ( <StampsSeals.SpecialtyStamps.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/StampAccessories') {
    return ( <StampsSeals.StampAccessories.Component submitForm={submitForm} /> );
  }
  if (component === './StampsSeals/TraditionalRubberStamps') {
    return ( <StampsSeals.TraditionalRubberStamps.Component submitForm={submitForm} /> );
  }

  // console.error(`ComponentLoader: component not found: ${component}`);


  return null;
};

ComponentLoader.propTypes = {
  component: PropTypes.string.isRequired,
  submitForm: PropTypes.object.isRequired,
};

export default ComponentLoader;
